import { MODULE_SWITCHER_STATE } from '../nativeMessageConstants';
import { sendScenarioDataToHost } from './sendScenarioDataToHost';

export function hideNativeModuleSwitcher() {
    sendScenarioDataToHost({
        type: MODULE_SWITCHER_STATE,
        data: { mounted: false },
    });
}
